import { Card, Col, Image, Row, Spin } from "antd";
import React, { FC, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import styled from "styled-components";
import { Button3D } from "../../../Components/Button3D";
import { SmallText } from "../../../Components/Text3D";
// import Ellispe1 from "../../../assets/images/Ellipse.png";
import { useQuery } from "@apollo/client";
import { MY_DESIGNS } from "../../../Apollo/graphql/Query";
// import Skeleton3D from '../../../Components/Skeleton3D';
// import Img3D from "../../../Components/Model3D";
// import { useStoreState } from 'easy-peasy';
import LikeDesign from "../../../Components/LikeDesign";
import { fallBackImage, getUserData } from "../../../utils/utilsFunctions";
import { CommentOutlined } from "@ant-design/icons";
import InfiniteScroll from "react-infinite-scroll-component";
import NullDataComp from "../../../Components/NullDataComp";


const MainWrapper = styled(Row)`
  
  /* &:before{
      content: '';
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 20px solid white;
      margin-left: 600px;
    } */
`;

const ContentWrapper = styled.div`
  background-color: white;
  font-family: "Planer", -apple-system, BlinkMacSystemFont, sans-serif;
  width: 100%;

`;
const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 0.5rem;
  margin: 0 2rem;
  border-bottom: 1px solid #d8d8d8;
`;
const ContentSection = styled(Row)`
  padding: 2rem;
`;
const CardX = styled(Card)`
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08);

  .ant-card-cover{
    height: 250px;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    display: flex;
    .ant-image {
      height: 100%;
      text-align: center;
    }
  }
`;

const Img = styled(Image)`
display: inline-block;
width: auto;
max-width: 100%;
height: 100%;
object-fit: contain;
/* max-inline-size: 100%;
block-size: auto;
aspect-ratio: 2/1;
object-fit: cover;   */
`


// const SectionDiv = styled.div`
//     background-color: #3d3d3d;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     height: 100%;

// `
const InfoDiv = styled.div`
  display: flex;
  flex-direction: column;
  .info-text-title {
    text-transform: capitalize;
    font-size: 1rem;
    color: #000;
    font-weight: 700;
  }
  .design-info {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
  }
  .info-text {
    text-transform: capitalize;
  }
`;
const AnchorComp = styled(Link)`
  display: block;
  text-decoration: none;
  color: #000;
  &:hover {
    color: #000;
  }
`;
const LikeDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`;
// const image3dStyle = {
//   top: 0,
//   right: 0,
//   alignItems: 'center',
//   height: '250px',
//   width: '100%'
// }

const MyDesigns: FC = () => {
  const [designs, setDesigns] = useState([]);
  const [loadedDesigns, setLoadedDesigns] = useState([])
  // const estimates = useStoreState((state: any) => state.estimates);

  const user = JSON.parse(getUserData('user'))

  const { loading } = useQuery(MY_DESIGNS, {
    variables: {
      pagination: {
        page: 1,
        limit: 100
      },
    },
    onCompleted: data => {
      setDesigns(data?.myDesigns?.designs)
      setLoadedDesigns(data?.myDesigns?.designs?.slice(0, 20));
    },
    onError: err => {
      console.log("Designs couldn't fetch")
    }
  })
  const loadMore = () => {
    // TODO:FIX THIS
    setTimeout(() => {
      setLoadedDesigns(designs.slice(0, loadedDesigns.length + 20));
    }, 1000);
  };
  const history = useHistory();
  // const preview3dModal = (design) => (
  //   <div style={{ padding: "1rem" }}>
  //     <Img3D url={design?.design} style={image3dStyle} />
  //   </div>
  // );

  return (
    <Spin spinning={loading}>
      <MainWrapper>
        <ContentWrapper>
          <TopSection>
            <SmallText small>
              <strong style={{ marginRight: "10px" }}>Total Designs:</strong> {designs.length}{" "}
              items
            </SmallText>
            <Button3D
              type="primary"
              onClick={() => history.push("/dashboard/design/addnew")}
            >
              upload new designs
            </Button3D>
          </TopSection>
          <InfiniteScroll
            dataLength={loadedDesigns.length}
            next={loadMore}
            hasMore={true}
            loader=""
            style={{ margin: "2rem 0", overflow: "unset" }}
            scrollableTarget="scrollableDiv"
          >
            <ContentSection gutter={[32, 32]}>
              {/* {loading && <Skeleton3D />}
            {
              designs && designs.map((design: any) => {
                return (
                  <Col xl={{ span: 8 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} key={design._id}>
                    <AnchorComp href={`/design/${design._id}`}>
                      <CardX
                        // cover={<img src={design.design} alt='' height={275} width='100%'/>}
                        cover={design?.design?.endsWith('.stl') ? <Img3D url={design.design} style={image3dStyle} /> : <Image src={design.design} alt="" />}
                      >
                        <Text>{design?.brand}</Text>
                        <DesignDiv>
                          <Text>
                            <strong>{design.name}</strong>
                          </Text>
                          <LikeDesign design={design} user={user}></LikeDesign>
                        </DesignDiv>

                        <hr style={{ border: '1px solid #E3E3E3' }} />
                        <div
                          style={{
                            display: "flex",
                          }}
                        >
                          <CommentOutlined
                            style={{
                              fontSize: "1.2rem",
                              marginRight: 10,
                            }}
                          />
                          {"0"}
                          <span style={{ marginLeft: 5 }}>Comments</span>
                        </div>
                      </CardX>
                    </AnchorComp>
                  </Col>
                )
              })
            }
            <Col span={8}>
              <SectionDiv>
                <img src={Ellispe1} alt="" onClick={() => history.push("/dashboard/upload/designs")} />
              </SectionDiv>
            </Col> */}
              {loading && <NullDataComp />}
              {loadedDesigns && loadedDesigns.length === 0 && (
                <NullDataComp />
              )}
              {loadedDesigns &&
                loadedDesigns.map((design: any, i) => {
                  return (
                    <Col
                      xl={{ span: 8 }}
                      md={{ span: 12 }}
                      sm={{ span: 24 }}
                      xs={{ span: 24 }}
                      key={design._id}
                    >
                      {/* <Popover content={() => preview3dModal(design)}> */}
                        <AnchorComp to={`/design/${design._id}`}>
                          <CardX
                            loading={false}
                            cover={
                              <Img
                                alt={design.name}
                                src={design.featuredImage || fallBackImage}
                                fallback={fallBackImage}
                                preview={false}
                              />
                            }
                          >
                            <InfoDiv>
                              <div>
                                <strong className="info-text-title">
                                  {design?.name}
                                </strong>
                              </div>
                              <div className="design-info">
                                <div>
                                  by{" "}
                                  <span className="info-text">
                                    {" "}
                                    {design?.owner?.firstName}{" "}
                                  </span>
                                </div>
                                <LikeDiv>
                                  <LikeDesign design={design} user={user} />
                                </LikeDiv>
                              </div>
                              <hr
                                style={{
                                  width: "100%",
                                  border: "1px solid #D8D8D8",
                                }}
                              />
                              <div
                                style={{
                                  display: "flex",
                                }}
                              >
                                <CommentOutlined
                                  style={{
                                    fontSize: "1.2rem",
                                    marginRight: 10,
                                  }}
                                />
                                {"0"}
                                <span style={{ marginLeft: 5 }}>Comments</span>
                              </div>
                            </InfoDiv>
                          </CardX>
                        </AnchorComp>
                      {/* </Popover> */}
                    </Col>
                  );
                })}
            </ContentSection>
          </InfiniteScroll>
        </ContentWrapper>
      </MainWrapper>
    </Spin>
  );
};
export default MyDesigns;
